import React from 'react';
import ReactDOM from 'react-dom/client';
import './Static/index.css';
import App from './App';
import store from './Store/Store';
import { Provider } from "react-redux";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
      
    </Provider>
  </React.StrictMode>
);
